import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import useProductContent from '@/composables/useProductContent/useProductContent';
import { useGetTranslations } from '@/composables/useGetTranslations';
import RichText from '~/components/ui/RichText';
export default {
  name: 'ItemRecipePreparationStep',
  components: {
    RichText: RichText,
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    number: Number,
    ingredientsOrEquipments: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    description: {
      type: Object,
      default: function _default() {}
    },
    phase: String
  },
  setup: function setup(props) {
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var options = {
      renderMark: {
        bold: function bold(text) {
          return "<span class=\"purple-text\">".concat(text, "</span>");
        }
      }
    };
    var components = computed(function () {
      return mapComponentName(props.ingredientsOrEquipments, {
        stepPhase: props.phase
      });
    });
    return {
      options: options,
      components: components,
      translate: translate
    };
  }
};